import { useTexture } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { useRef } from 'react'
import { patterns } from '../../textures';
import * as THREE from 'three'

const TopPanelTexture = ({ repeat, normal }) => {

    const snap = useSnapshot(state.current)

    const ref = useRef()
    let texture = useTexture(patterns[snap.choices.topPanel.selected.src])
    let normalTexture = useTexture(patterns.normal)
    texture.repeat.set(repeat, repeat);
    texture.wrapS = THREE.RepeatWrapping
    texture.wrapT = THREE.RepeatWrapping
    texture.needsUpdate = true
    normalTexture.repeat.set(repeat, repeat);
    normalTexture.wrapS = THREE.RepeatWrapping
    normalTexture.wrapT = THREE.RepeatWrapping
    normalTexture.needsUpdate = true

    return (

        <meshStandardMaterial
            ref={ref}
            map={texture}
            repeat={repeat}
            normalMap={normal}
            onUpdate={(self) => (self.needsUpdate = true)}
            normalScale={new THREE.Vector2(1, 5)}
            side={THREE.DoubleSide}
            roughness={.8}
            metalness={0}
        />
    );
};

export default TopPanelTexture;